import { render } from "./BirthView.vue?vue&type=template&id=22c59920"
import script from "./BirthView.vue?vue&type=script&lang=js"
export * from "./BirthView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__